import React from "react";

const styles = (theme) => ({

});

let _this = { IDs: ["recaptcha"], onChange: () => { } };
window.onloadCallback = () => {
  _this.IDs.forEach((id) => {
    try {
      window.grecaptcha.render(id, {
        sitekey: window.config.recaptcha.sitekey,
        callback: _this.onChange,
      });
    } catch (err) { }
  });
};

class Recaptcha extends React.Component {
  appendRecaptchaScript = () => {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=sk";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  };

  componentDidMount() {
    const { id, onChange } = this.props;
    const IDs = [..._this.IDs];

    if (id) IDs.push(id);
    _this = { IDs, onChange };

    this.appendRecaptchaScript();
  }

  render() {
    const { id } = this.props;
    return <div id={id || "recaptcha"} />;
  }
}

export default Recaptcha;
